import axios from "axios";
import api from "@/api/api";

/**
 * EPCIS 이벤트 커밋 대기 (폴링)
 * @param {string} eventID EPCIS 이벤트 ID
 * @param {object} opt { timeout, startInterval, maxInterval }
 */
export async function pollEpcisEvent(eventID, opt = {}) {
  const timeout = opt.timeout ?? 60000;   // 최대 대기 시간
  let interval  = opt.startInterval ?? 800; // 시작 간격
  const cap     = opt.maxInterval ?? 4000;  // 최대 간격
  const endAt   = Date.now() + timeout;

  while (true) {
    try {
      const { data } = await axios.get(`/api/epcisAPI/events`, {
        params: { paths: `events/${eventID}` }
      });
      if (data && Object.keys(data).length) return data; // 성공시 반환
    } catch (e) {
      const st = e?.response?.status;
      if (st && st !== 404 && st !== 500) throw e; // 나머지는 오류로 throw
    }

    if (Date.now() > endAt) {
      throw new Error("EPCIS 이벤트가 제한 시간 내 조회되지 않았습니다.");
    }
    await new Promise(r => setTimeout(r, interval));
    interval = Math.min(interval * 2, cap); // 지수 백오프
  }
}

/**
 * 블록체인에 EPCIS 이벤트 저장
 * @param {string} key 이벤트 ID
 * @param {object} data EPCIS 이벤트 데이터
 * @param {number} timeoutMs 타임아웃(ms)
 */
export async function saveBlockChain(key, data, timeoutMs = 60000, retryCount = 0) {
  try {
    const res = await api.post("/tx/command", {
      operation: "createEpcisEvent",
      key,
      data
    });

    const statusUrl = res.data.statusUrl;
    const start = Date.now();

    /* while (true) {
      const st = (await api.get(statusUrl)).data;
      if (st.state === "SENT" || st.state === "DEAD") {
        return st; // 최종 상태 반환
      }

      if (Date.now() - start > timeoutMs) {
        throw new Error("블록체인 처리 결과가 제한 시간 내 확인되지 않았습니다.");
      }

      await new Promise(r => setTimeout(r, 1500));
    } */
  } catch (e) {
    if (e.response && e.response.status === 502) {
      console.warn(`502 오류 발생 — 2초 뒤 재시도합니다. (시도 ${retryCount + 1})`);
      if (retryCount < 3) { // 최대 3회 재시도 제한 (원하시면 늘릴 수 있음)
        await new Promise(r => setTimeout(r, 2000));
        return saveBlockChain(key, data, timeoutMs, retryCount + 1);
      }
    }
    console.error(e);
    throw new Error("블록체인 통신 오류");
  }
}
